
const topTrackRecordMap = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    const secTrackRecord = document.getElementById('jsSecTrackRecord');

    const trWrap = secTrackRecord.querySelector('.js-tr-wrap');

    const mapArea = trWrap.querySelector('.js-map-area');
    const mapBox = mapArea.querySelector('.js-map-box');

    const listArea = trWrap.querySelector('.js-list-area');
    const areaBox = listArea.querySelectorAll('.js-area-box');
    const listBox = listArea.querySelectorAll('.js-list-box');
    const scroll = listArea.querySelectorAll('.js-scroll');



    // りせっと
    const reset = () => {
      for (let i = 0; i < areaBox.length; i++) {
        areaBox[i].classList.remove('act');
        listBox[i].classList.remove('act');
        mapBox.classList.remove('tokyo');
        mapBox.classList.remove('kansai');
        mapBox.classList.remove('kyushu');
      }
    }


    // マップクリック
    mapArea.addEventListener('click', (event) => {
      reset()
    });


    // アコーディオン
    let flagScroll0 = 0
    let flagScroll1 = 0
    let flagScroll2 = 0

    areaBox.forEach((element, index) => {

      element.addEventListener('click', (event) => {

        if (element.classList.contains('act') == true) {

          reset()

        } else {

          for (let i = 0; i < areaBox.length; i++) {
            reset()
          }

          areaBox[index].classList.add('act');
          listBox[index].classList.add('act');

          if (index == 0) {

            mapBox.classList.add('tokyo');

            if (flagScroll0 == 0) {
              setTimeout(() => {
                scroll[index].classList.add('act');
              }, 600);
              setTimeout(() => {
                scroll[index].classList.remove('act');
              }, 6600);
            }
            flagScroll0 = 1

          }

          if (index == 1) {

            mapBox.classList.add('kansai');

            if (flagScroll1 == 0) {
              setTimeout(() => {
                scroll[index].classList.add('act');
              }, 600);
              setTimeout(() => {
                scroll[index].classList.remove('act');
              }, 6600);
            }
            flagScroll1 = 1

          }
          
          if (index == 2) {
          
            mapBox.classList.add('kyushu');
            
            if (flagScroll2 == 0) {
              setTimeout(() => {
                scroll[index].classList.add('act');
              }, 600);
              setTimeout(() => {
                scroll[index].classList.remove('act');
              }, 6600);
            }
            flagScroll2 = 1
          
          }
        }

      });

    });



    // areaBox[0].classList.add('act');
    // listBox[0].classList.add('act');
    // areaBox[1].classList.add('act');
    // listBox[1].classList.add('act');
    // areaBox[2].classList.add('act');
    // listBox[2].classList.add('act');


  }
})();
export default topTrackRecordMap;